$(document).ready(subscriptionFormComponent);

function subscriptionFormComponent() {

    if ($("[data-position=0]") != null) {

        var urlHashValue = parseInt(window.location.hash.substr(1));
        if (urlHashValue == '' || isNaN(urlHashValue)) {
            urlHashValue = $('.subscription-index[data-position=0]').attr('data-id');
        }
        $('#subscriptionOptionId').val(urlHashValue);
        if (urlHashValue != "") {

            $("[data-value=" + urlHashValue + "]").show()
            var other = $('.subscription-index[data-id!=' + urlHashValue + ']').attr('data-id');
            $("[data-value-button=" + other + "]").show()
            $('input[type=radio][name=changeSubscriptionType][value= ' + urlHashValue + ']').prop('checked', 'true')

        } else {
            var first = $('.subscription-index[data-position=0]').attr('data-id');
            var second = $('.subscription-index[data-position!=0]').attr('data-id');
            $("[data-value=" + first + "]").show()
            $("[data-value-button=" + second + "]").show()
        }
    }

    $('input[type=radio][name=packSubscription], input[type=radio][name=supportSubscription]').change(function() {

        var supportInputIds;
        var subscriptionId;

        if (exists('input[type=radio][name=supportSubscription]')) {
            supportInputIds = $('input[type=radio][name=supportSubscription]:checked').attr('subscriptionIds').split(',').filter(x => x != "")
        }
        const packInputIds = $('input[type=radio][name=packSubscription]:checked').attr('subscriptionIds').split(',').filter(x => x != "")

        if (packInputIds.length > 1) {
            subscriptionId = supportInputIds.filter(value => packInputIds.includes(value));
        } else {
            subscriptionId = packInputIds[0]
        }
        
        showSubscription(subscriptionId)
    });

    // prevent click on btn-table from opening order-controls
    $(".btn-table").click(function(e) {
        e.stopPropagation();
    });


    function initializePayment(orderId) {
        $.ajax({
            type: "POST",
            url: '/restful/shopping/checkout/payment/initialize',
            data: { orderId: orderId },
            dataType: 'json',
            success: function(data) {
                if (data.success) {
                    window.location = '/current/checkout/billing';
                } else {
                    alert('Cannot pay this order.');
                }
            },
            failed: function(data) {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
            }
        });
    }


    // activate form ajax
    $('#subscription-activate-form').submit(function(event) {
        event.preventDefault();
        var $form = $(this);

        if(!$('#terms').is(':checked')) {
            showMessageBox('danger', msg['ERR_PRIVACY']);
        } else if (!$('#contract').is(':checked')) {
            showMessageBox('danger', msg['ERR_CONTRACT']);
        } else if (!$('#customCheckbox').is(':checked') && exists('#customCheckbox')) {
            showMessageBox('danger', msg['ERR_CONTRACT']);
        } else {
            $.ajax({
                type: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize(),
                dataType: 'json',
                beforeSend: function(data) {
                    $form.find(':input').prop('disabled', true);
                },
                success: function(data) {
                    if (data.success) {
                        initializePayment(data.data);
                    }
                    else {
                        showMessageBox('danger', msg['MSG_GENERIC_ERROR'] + '. ' + (msg[data.errors.message] || data.errors.message));
                    }
                },
                failed: function(data) {
                    showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
                },
                complete: function(data) {
                    $form.find(':input').prop('disabled', false);
                }
            });
        }
    });


    // profile reactivate form ajax
    $('.subscription-reactivate-form').submit(function(event) {
        event.preventDefault();
        var $form = $(this);

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function(data) {

            },
            success: function(data) {
                if (data.success) {
                    window.location.reload();
                }
                else {
                    showMessageBox('danger', msg['MSG_CANNOT_REACTIVATE_EXPIRED']);
                }
            },
            failed: function(data) {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
            },
            complete: function(data) {
            }
        });
    });


    // profile unsubscribe form ajax
    $('.subscription-unsubscribe-form').submit(function(event) {
        event.preventDefault();
        var $form = $(this);

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function(data) {

            },
            success: function(data) {
                if (data.success == false) {
                    showMessageBox('danger', data.errors.message);
                }
            },
            failed: function(data) {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
            },
            complete: function(data) {
                window.location.reload();
            }
        });
    });

    $('.subscription-change-form').submit(function(event) {
        event.preventDefault();
        var $form = $(this);

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function(data) {

            },
            success: function(data) {
                if (data.success == false) {
                    showMessageBox('danger', data.errors.message);
                }
            },
            failed: function(data) {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
            },
            complete: function(data) {
                window.location.reload();
            }
        });
    });

    // profile pay form ajax
    $('.pay-subscription').on('click', function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var $this = $(this);
        initializePayment($this.attr('data-order-id'));
    });

    $('.change-subscription').click(function(event) {
        event.preventDefault();
        var $form = $('.subscription-change-form');

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'json',
            beforeSend: function(data) {

            },
            success: function(data) {
                if (data.success == false) {
                    showMessageBox('danger', data.errors.message);
                }
            },
            failed: function(data) {
                showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
            },
            complete: function(data) {
                window.location.reload();
            }
        });
    });
}

function showSubscription(id) {
    var other = $('.subscription-index[data-id!=' + id + ']').attr('data-id');
    $('.subscription-element').hide()
    $("[data-value=" + id + "]").fadeIn();
    $("[data-value-button=" + other + "]").fadeIn()
    $('#subscriptionOptionId').val(id);
}